import React, { useMemo } from 'react';
import AdminSearchInput from './AdminSearchInput';
import SearchTypeSelect from './SearchTypeSelect';
import { renderAdvancedSearchHighlight } from './advancedSearchHighlight';

const AdminSearchBar = ({
  value,
  onChange,
  placeholder = 'Rechercher...',
  highlightContent = null,
  imgBack = null,
  showSearchRules = false,
  optionValue = '',
  onOptionChange,
  searchOptions = [],
  showTypeSelect = false,
  inputWrapperClassName = 'flex-1',
  selectWrapperClassName = 'w-[140px]',
  selectClassName = '',
}) => {
  const resolvedHighlight = useMemo(() => {
    if (highlightContent !== null) return highlightContent;
    if (showSearchRules) return renderAdvancedSearchHighlight(value);
    return null;
  }, [highlightContent, showSearchRules, value]);

  return (
    <div className="flex gap-2 items-center w-full">
      <div className={inputWrapperClassName}>
        <AdminSearchInput
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          highlightContent={resolvedHighlight}
          imgBack={imgBack}
          showSearchRules={showSearchRules}
        />
      </div>
      {showTypeSelect && (
        <div className={selectWrapperClassName}>
          <SearchTypeSelect
            value={optionValue}
            onChange={onOptionChange}
            options={searchOptions}
            className={selectClassName}
          />
        </div>
      )}
    </div>
  );
};

export default AdminSearchBar;
